import { Component, Input } from '@angular/core';
import { NzIconModule } from 'ng-zorro-antd/icon';
@Component({
  selector: 'app-bridge-hire-icon',
  imports: [NzIconModule],
  templateUrl: './bridge-hire-icon.html',
  styleUrl: './bridge-hire-icon.css',
})
export class BridgeHireIcon {
  @Input() size: number | string = 32;
  @Input() color: string = '';
}
